import { render, staticRenderFns } from "./PageSeo.vue?vue&type=template&id=c5cc73b6&"
import script from "./PageSeo.vue?vue&type=script&lang=js&"
export * from "./PageSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports